import React from 'react';

interface ScoreBadgeProps {
  score: number;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score, label = 'Impact', size = 'md' }) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-[9px]',
    md: 'px-3 py-2 text-[10px]',
    lg: 'px-4 py-3 text-xs'
  };

  const scoreSizeClasses = {
    sm: 'text-sm',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className={`bg-slate-50 px-3 py-2 rounded-xl flex flex-col items-center border border-slate-100 shrink-0 ${sizeClasses[size]}`}>
      <span className="font-black text-slate-400 uppercase tracking-tighter">{label}</span>
      <div className={`font-black text-slate-900 ${scoreSizeClasses[size]}`}>{score}%</div>
    </div>
  );
};

export default ScoreBadge;
